import {useValueLists} from '../http/value-lists';
import {Button} from '@ui/buttons/button';
import {LanguageIcon} from '@ui/icons/material/Language';
import {KeyboardArrowDownIcon} from '@ui/icons/material/KeyboardArrowDown';
import {Menu, MenuItem, MenuTrigger} from '@ui/menu/menu-trigger';
import {useSelectedLocale} from '@ui/i18n/selected-locale';
import {useChangeLocale} from '@common/locale-switcher/change-locale';
import {useSettings} from '@ui/settings/use-settings';
import { Trans } from '@ui/i18n/trans';
import { ButtonSize } from '@ui/buttons/button-size';
import { ButtonVariant, ButtonColor } from '@ui/buttons/get-shared-button-style';
import clsx from 'clsx';
import { useInitShortcuts } from '@common/core/capacitor/shortcut/use-init-shortcuts';

type LocaleSwitcherProps = {
  text?: boolean;
  startIcon?: boolean;
  endIcon?: boolean;
  buttonVariant?: ButtonVariant;
  buttonColor?: ButtonColor;
  buttonSize?: ButtonSize;
  buttonClassName?: string;
};

export function LocaleSwitcher({
  text = true,
  startIcon = true,
  endIcon = true,
  buttonVariant,
  buttonColor,
  buttonSize,
  buttonClassName = "",
}: LocaleSwitcherProps) {
  const {locale} = useSelectedLocale();
  const changeLocale = useChangeLocale();
  const {data} = useValueLists(['localizations']);
  const {i18n} = useSettings();
  
  if (!data?.localizations || !locale || !i18n.enable) return null;
  
  return (
    <MenuTrigger
      floatingWidth="matchTrigger"
      selectionMode="single"
      selectedValue={locale.language}
      onSelectionChange={value => {
        const newLocale = value as string;
        if (newLocale !== locale?.language) {
          changeLocale.mutate({locale: newLocale});
        }
      }}
    >
      <Button
        variant={buttonVariant}
        color={buttonColor}
        size={buttonSize}
        disabled={changeLocale.isPending}
        className={clsx(
          "capitalize",
          buttonClassName
        )}
        startIcon={startIcon ? <LanguageIcon /> : null}
        endIcon={endIcon ? <KeyboardArrowDownIcon /> : null}
      >
        {text && locale.name}
      </Button>
      <Menu>
        {data.localizations.map(localization => (
          <MenuItem
            value={localization.language}
            key={localization.language}
            className="capitalize"
          >
            {localization.name}
          </MenuItem>
        ))}
      </Menu>
    </MenuTrigger>
  );
}
